import { __decorate } from "tslib";
import { Route } from '../core';
var Attributes = /*@__PURE__*/ (function () {
    function Attributes() {
    }
    Attributes.get = function (response) {
        return response;
    };
    Attributes = __decorate([
        Route('/vlux/attributes/attributes.json')
    ], Attributes);
    return Attributes;
}());
export { Attributes };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/attributes.ts
// module id = null
// module chunks = 